<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :search="search"
    item-key="codigo"
    fixed-header
    height="550px"
    :footer-props="footerProps"
    dense
    class="
      elevation-1
      exportaciones-table
    "
  >
    <v-progress-linear
      slot="progress"
      color="deep-orange"
      indeterminate
    ></v-progress-linear>

    <template v-slot:item.salud="{ item }">
      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-chip
            x-small
            outlined
            :color="
              saludProgramacion(item).color
            "
            v-bind="attrs"
            v-on="on"
          >
            <v-icon
              x-small
              left
            >
              {{
                saludProgramacion(item)
                  .icono
              }}
            </v-icon>

            {{
              saludProgramacion(item)
                .texto
            }}
          </v-chip>
        </template>

        <span>
          {{
            saludProgramacion(item)
              .descripcion
          }}
        </span>
      </v-tooltip>
    </template>

    <template v-slot:item.grupo="{ item }">
      <span v-if="item.grupo">
        {{ item.grupo.nombre }}
      </span>

      <span v-else class="grey--text">
        Sin grupo
      </span>
    </template>

    <template v-slot:item.periodo="{ item }">
      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <div
            class="
              d-inline-flex
              align-center
            "
            v-bind="attrs"
            v-on="on"
          >
            <span>
              {{ nombrePeriodo(item.periodo) }}
            </span>

            <v-icon
              x-small
              color="grey"
              class="ml-1"
            >
              mdi-information-outline
            </v-icon>
          </div>
        </template>

        <span>
          {{
            descripcionPeriodo(
              item.periodo
            )
          }}
        </span>
      </v-tooltip>
    </template>

    <template v-slot:item.formato="{ item }">
      <v-chip
        x-small
        outlined
        :color="
          colorFormato(
            item.formato
          )
        "
      >
        {{
          nombreFormato(
            item.formato
          )
        }}
      </v-chip>
    </template>

    <template v-slot:item.programacion="{ item }">
      <div>
        {{
          formatearProximaEjecucion(
            item.programacion &&
              item.programacion
                .fecha_proxima_ejecucion
          )
        }}
      </div>

      <div class="caption grey--text">
        {{
          item.programacion
            ? item.programacion.expresion_cron
            : ""
        }}
      </div>
    </template>

    <template v-slot:item.onedrive="{ item }">
      <div v-if="item.onedrive">
        <div>
          {{ item.onedrive.nombre }}
        </div>

        <div class="caption grey--text">
          {{ item.onedrive.cuenta }}
        </div>

        <div class="caption grey--text">
          {{ item.onedrive.carpeta }}
        </div>
      </div>

      <span v-else class="grey--text">
        Sin destino OneDrive
      </span>
    </template>

    <template v-slot:item.estado="{ item }">
      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            small
            rounded
            depressed
            dark
            :color="colorEstado(item.estado)"
            :loading="
              codigoProcesando === item.codigo
            "
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="
              $emit(
                'cambiar-estado',
                item
              )
            "
          >
            {{
              item.estado
                ? item.estado.nombre
                : "Sin estado"
            }}
          </v-btn>
        </template>

        <span>
          {{
            esActiva(item)
              ? "Desactivar programación"
              : "Activar programación"
          }}
        </span>
      </v-tooltip>
    </template>

    <template
      v-slot:item.ultima_ejecucion="{ item }"
    >
      <div v-if="item.ultima_ejecucion">
        <v-chip
          x-small
          outlined
          :color="
            colorEjecucion(
              item.ultima_ejecucion.estatus
            )
          "
        >
          {{
            nombreEstatusEjecucion(
              item.ultima_ejecucion.estatus
            )
          }}
        </v-chip>

        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
          >
            <div
              class="caption mt-1"
              v-bind="attrs"
              v-on="on"
            >
              {{
                formatearTiempoRelativo(
                  item.ultima_ejecucion
                    .fecha_fin
                )
              }}
            </div>
          </template>

          <span>
            {{
              formatearFechaExacta(
                item.ultima_ejecucion
                  .fecha_fin
              )
            }}
          </span>
        </v-tooltip>

        <div class="caption grey--text">
          {{
            formatearCantidad(
              item.ultima_ejecucion
                .cantidad_resultados
            )
          }}
          resultados
        </div>
      </div>

      <span v-else class="grey--text">
        Sin ejecuciones
      </span>
    </template>

    <template v-slot:item.acciones="{ item }">
      <v-tooltip
        v-if="
          item.ultima_ejecucion &&
          item.ultima_ejecucion.url
        "
        bottom
      >
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="
              $emit(
                'abrir-archivo',
                item.ultima_ejecucion.url
              )
            "
          >
            <v-icon small>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </template>

        <span>Abrir último archivo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="deep-orange"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="$emit('editar', item)"
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>

        <span>
          Editar programación
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="blue-grey"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="$emit('duplicar', item)"
          >
            <v-icon small>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>

        <span>
          Duplicar programación
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="error"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="
              $emit(
                'eliminar',
                item
              )
            "
          >
            <v-icon small>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>

        <span>
          Eliminar programación
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="blue-grey"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="
              $emit(
                'vista-previa',
                item
              )
            "
          >
            <v-icon small>
              mdi-eye-outline
            </v-icon>
          </v-btn>
        </template>

        <span>
          Ver vista previa
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="success"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="$emit('ejecutar', item)"
          >
            <v-icon small>
              mdi-play
            </v-icon>
          </v-btn>
        </template>

        <span>
          Ejecutar ahora
        </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template
          v-slot:activator="{ on, attrs }"
        >
          <v-btn
            icon
            small
            color="primary"
            :disabled="loading"
            v-bind="attrs"
            v-on="on"
            @click="$emit('historial', item)"
          >
            <v-icon small>
              mdi-history
            </v-icon>
          </v-btn>
        </template>

        <span>
          Ver historial de ejecuciones
        </span>
      </v-tooltip>
    </template>

    <template v-slot:no-data>
      No hay exportaciones programadas
    </template>

    <template v-slot:no-results>
      No se obtuvieron resultados
    </template>

    <template v-slot:footer.page-text="props">
      Página {{ props.pageStart }} -
      {{ props.pageStop }} de
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";

export default {
  name: "ExportacionesProgramadasTable",

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },

    search: {
      type: String,
      default: "",
    },

    codigoProcesando: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    footerProps: {
      "items-per-page-text":
        "Elementos por página",
      "items-per-page-options":
        [10, 25, 50, -1],
    },

    headers: [
      {
        text: "Nombre",
        value: "nombre",
        align: "start",
        width: "150px",
      },
      {
        text: "Salud",
        value: "salud",
        align: "center",
        sortable: false,
        width: "95px",
      },
      {
        text: "Grupo",
        value: "grupo",
        align: "start",
        width: "100px",
      },
      {
        text: "Periodo",
        value: "periodo",
        align: "center",
        sortable: false,
        width: "100px",
      },
      {
        text: "Formato",
        value: "formato",
        align: "center",
        width: "72px",
      },
      {
        text: "Próxima ejecución",
        value: "programacion",
        align: "center",
        sortable: false,
        width: "118px",
      },
      {
        text: "OneDrive",
        value: "onedrive",
        align: "start",
        sortable: false,
        width: "205px",
      },
      {
        text: "Estado",
        value: "estado",
        align: "center",
        sortable: false,
        width: "92px",
      },
      {
        text: "Última ejecución",
        value: "ultima_ejecucion",
        align: "center",
        sortable: false,
        width: "125px",
      },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        width: "155px",
      },
    ],
  }),

  created() {
    moment.locale("es");
  },

  methods: {
    saludProgramacion(item) {
      if (!this.esActiva(item)) {
        return {
          texto: "Inactiva",
          color: "grey",
          icono:
            "mdi-pause-circle-outline",
          descripcion:
            "La programación está desactivada y no se ejecutará automáticamente.",
        };
      }

      const ultima =
        item &&
        item.ultima_ejecucion
          ? item.ultima_ejecucion
          : null;

      if (!ultima) {
        return {
          texto: "Sin ejecutar",
          color: "warning",
          icono:
            "mdi-clock-alert-outline",
          descripcion:
            "La programación todavía no tiene ejecuciones registradas.",
        };
      }

      if (
        ultima.estatus === "error" ||
        ultima.estatus === "fallida"
      ) {
        return {
          texto: "Error",
          color: "error",
          icono:
            "mdi-alert-circle-outline",
          descripcion:
            "La última ejecución terminó con error.",
        };
      }

      if (
        ultima.estatus === "parcial"
      ) {
        return {
          texto: "Parcial",
          color: "deep-orange",
          icono:
            "mdi-alert-outline",
          descripcion:
            "La última ejecución generó el archivo, pero alguno de los destinos presentó problemas.",
        };
      }

      if (
        ultima.estatus === "sin_datos"
      ) {
        return {
          texto: "Sin datos",
          color: "info",
          icono:
            "mdi-database-off-outline",
          descripcion:
            "La última ejecución no encontró registros para el periodo solicitado.",
        };
      }

      if (
        ultima.estatus ===
        "en_proceso"
      ) {
        return {
          texto: "Ejecutando",
          color: "primary",
          icono:
            "mdi-progress-clock",
          descripcion:
            "La exportación se encuentra en proceso.",
        };
      }

      return {
        texto: "Correcta",
        color: "success",
        icono:
          "mdi-check-circle-outline",
        descripcion:
          "La última ejecución terminó correctamente.",
      };
    },

    esActiva(item) {
      return Boolean(
        item &&
        item.estado &&
        (
          item.estado.id === 1 ||
          item.estado.nombre ===
            "activo"
        )
      );
    },

    nombrePeriodo(periodo) {
      if (!periodo || !periodo.tipo) {
        return "Sin periodo";
      }

      const nombres = {
        dia_anterior: "Día anterior",
        dia_actual: "Día actual",
        mes_anterior: "Mes anterior",
      };

      if (
        periodo.tipo === "ultimos_n_dias"
      ) {
        return periodo.cantidadDias
          ? `Últimos ${periodo.cantidadDias} días`
          : "Últimos días";
      }

      return nombres[periodo.tipo] ||
        periodo.tipo;
    },

    descripcionPeriodo(periodo) {
      if (!periodo || !periodo.tipo) {
        return (
          "No hay un periodo de registro " +
          "configurado."
        );
      }

      if (
        periodo.tipo === "dia_anterior"
      ) {
        return (
          "Se incluirán las encuestas " +
          "registradas en el servidor " +
          "durante el día anterior."
        );
      }

      if (
        periodo.tipo === "dia_actual"
      ) {
        return (
          "Se incluirán las encuestas " +
          "registradas en el servidor " +
          "durante el día actual."
        );
      }

      if (
        periodo.tipo === "mes_anterior"
      ) {
        return (
          "Se incluirán las encuestas " +
          "registradas en el servidor " +
          "durante el mes calendario anterior."
        );
      }

      if (
        periodo.tipo === "ultimos_n_dias"
      ) {
        const cantidad =
          periodo.cantidadDias ||
          periodo.cantidad_dias ||
          "";

        return cantidad
          ? (
              "Se incluirán las encuestas " +
              "registradas en el servidor " +
              `durante los últimos ${cantidad} días.`
            )
          : (
              "Se incluirán las encuestas " +
              "registradas durante los " +
              "últimos días configurados."
            );
      }

      return (
        "El periodo se calcula usando la " +
        "fecha de registro de la encuesta " +
        "en el servidor."
      );
    },

    nombreFormato(formato) {
      return String(
        formato || "csv"
      ).toUpperCase();
    },

    colorFormato(formato) {
      return String(
        formato || ""
      ).toLowerCase() === "txt"
        ? "blue-grey"
        : "success";
    },

    formatearProximaEjecucion(fecha) {
      if (!fecha) {
        return "Sin programar";
      }

      const valor = moment(fecha);

      if (!valor.isValid()) {
        return fecha;
      }

      const hoy =
        moment().startOf("day");

      const fechaEjecucion =
        valor.clone().startOf("day");

      const diferenciaDias =
        fechaEjecucion.diff(
          hoy,
          "days"
        );

      const hora =
        valor.format("h:mm A");

      if (diferenciaDias === 0) {
        return `Hoy ${hora}`;
      }

      if (diferenciaDias === 1) {
        return `Mañana ${hora}`;
      }

      if (
        diferenciaDias > 1 &&
        diferenciaDias <= 6
      ) {
        const dia =
          valor.format("dddd");

        return (
          this.capitalizar(dia) +
          ` ${hora}`
        );
      }

      return (
        valor.format("D MMM") +
        ` ${hora}`
      );
    },

    formatearTiempoRelativo(fecha) {
      if (!fecha) {
        return "Sin ejecuciones";
      }

      const valor = moment(fecha);

      if (!valor.isValid()) {
        return fecha;
      }

      return valor.fromNow();
    },

    formatearFechaExacta(fecha) {
      if (!fecha) {
        return "Sin fecha";
      }

      const valor = moment(fecha);

      return valor.isValid()
        ? valor.format(
            "DD/MM/YYYY h:mm:ss A"
          )
        : fecha;
    },

    capitalizar(texto) {
      const valor =
        String(texto || "");

      if (!valor) {
        return "";
      }

      return (
        valor.charAt(0).toUpperCase() +
        valor.slice(1)
      );
    },

    formatearCantidad(valor) {
      return Number(valor || 0).toLocaleString(
        "es-MX"
      );
    },

    colorEstado(estado) {
      if (!estado) {
        return "grey";
      }

      if (
        estado.id === 1 ||
        estado.nombre === "activo"
      ) {
        return "success";
      }

      if (
        estado.id === 2 ||
        estado.nombre === "inactivo"
      ) {
        return "warning";
      }

      return "grey";
    },

    nombreEstatusEjecucion(estatus) {
      const nombres = {
        exitosa: "Exitosa",
        parcial: "Parcial",
        error: "Error",
        fallida: "Fallida",
        en_proceso: "En proceso",
        sin_datos: "Sin datos",
      };

      return nombres[estatus] || estatus;
    },

    colorEjecucion(estatus) {
      if (estatus === "exitosa") {
        return "success";
      }

      if (
        estatus === "error" ||
        estatus === "fallida"
      ) {
        return "error";
      }

      if (
        estatus === "en_proceso" ||
        estatus === "sin_datos"
      ) {
        return "info";
      }

      return "grey";
    },
  },
};
</script>

<style scoped>
::v-deep .exportaciones-table table {
  table-layout: fixed;
  width: 100%;
}

/*
 * La misma altura y el mismo espaciado para todos
 * los encabezados.
 */
::v-deep .exportaciones-table thead th {
  height: 58px;
  padding: 0 8px !important;
  line-height: 1.2;
  vertical-align: middle;
  white-space: normal;
}

/*
 * Vuetify coloca el texto dentro de un contenedor.
 * Lo hacemos ocupar toda la columna para que el
 * encabezado comparta exactamente el eje de la celda.
 */
::v-deep .exportaciones-table thead th > span,
::v-deep .exportaciones-table thead th .v-data-table-header__icon {
  vertical-align: middle;
}

/*
 * Espaciado uniforme en todas las celdas.
 */
::v-deep .exportaciones-table tbody td {
  padding: 8px !important;
  vertical-align: middle;
  line-height: 1.3;
}

/*
 * Columnas alineadas a la izquierda:
 * Nombre, Grupo y OneDrive.
 */
::v-deep .exportaciones-table th:nth-child(1),
::v-deep .exportaciones-table td:nth-child(1),
::v-deep .exportaciones-table th:nth-child(3),
::v-deep .exportaciones-table td:nth-child(3),
::v-deep .exportaciones-table th:nth-child(7),
::v-deep .exportaciones-table td:nth-child(7) {
  text-align: left !important;
}

/*
 * Columnas centradas:
 * Salud, Periodo, Formato, Próxima ejecución,
 * Estado, Última ejecución y Acciones.
 */
::v-deep .exportaciones-table th:nth-child(2),
::v-deep .exportaciones-table td:nth-child(2),
::v-deep .exportaciones-table th:nth-child(4),
::v-deep .exportaciones-table td:nth-child(4),
::v-deep .exportaciones-table th:nth-child(5),
::v-deep .exportaciones-table td:nth-child(5),
::v-deep .exportaciones-table th:nth-child(6),
::v-deep .exportaciones-table td:nth-child(6),
::v-deep .exportaciones-table th:nth-child(8),
::v-deep .exportaciones-table td:nth-child(8),
::v-deep .exportaciones-table th:nth-child(9),
::v-deep .exportaciones-table td:nth-child(9),
::v-deep .exportaciones-table th:nth-child(10),
::v-deep .exportaciones-table td:nth-child(10) {
  text-align: center !important;
}

/*
 * Nombre y Grupo pueden ocupar dos líneas sin
 * romper palabras de forma agresiva.
 */
::v-deep .exportaciones-table td:nth-child(1),
::v-deep .exportaciones-table td:nth-child(3) {
  white-space: normal;
  overflow-wrap: break-word;
}

::v-deep .exportaciones-table td:nth-child(1) {
  font-weight: 500;
}

/*
 * Salud, Formato y Estado siempre permanecen
 * centrados y compactos.
 */
::v-deep .exportaciones-table td:nth-child(2),
::v-deep .exportaciones-table td:nth-child(5),
::v-deep .exportaciones-table td:nth-child(8) {
  white-space: nowrap;
}

/*
 * Periodo y fechas pueden usar dos o tres líneas,
 * pero conservan el centro visual.
 */
::v-deep .exportaciones-table td:nth-child(4),
::v-deep .exportaciones-table td:nth-child(6),
::v-deep .exportaciones-table td:nth-child(9) {
  white-space: normal;
}

/*
 * OneDrive dispone ahora de más ancho. Permitimos
 * hasta varias líneas para nombre, cuenta y carpeta,
 * como en la propuesta visual.
 */
::v-deep .exportaciones-table td:nth-child(7) {
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.3;
}

/*
 * Chips compactos y centrados.
 */
::v-deep .exportaciones-table .v-chip.v-size--x-small {
  height: 22px;
  padding-left: 7px;
  padding-right: 7px;
}

/*
 * Estado conserva una forma uniforme.
 */
::v-deep .exportaciones-table td:nth-child(8) .v-btn,
::v-deep .exportaciones-table td:nth-child(8) .v-chip {
  min-width: 78px;
  justify-content: center;
}

/*
 * Acciones en una sola fila flexible y centrada.
 * Si la implementación contiene muchos botones,
 * pueden pasar a una segunda línea completa, pero
 * no quedan iconos aislados a distintas alturas.
 */
::v-deep .exportaciones-table td:last-child {
  padding-left: 4px !important;
  padding-right: 4px !important;
  white-space: normal;
  line-height: 1;
}

::v-deep .exportaciones-table td:last-child > div,
::v-deep .exportaciones-table td:last-child {
  text-align: center;
}

::v-deep .exportaciones-table td:last-child .v-btn {
  width: 26px;
  height: 26px;
  margin: 1px;
}

::v-deep .exportaciones-table td:last-child .v-icon {
  font-size: 16px !important;
}

/*
 * La fila mantiene una altura consistente aun cuando
 * Nombre, Grupo u OneDrive usen dos líneas.
 */
::v-deep .exportaciones-table tbody tr {
  min-height: 72px;
}

/*
 * Pie de tabla flexible.
 */
::v-deep .exportaciones-table .v-data-footer {
  flex-wrap: wrap;
  min-height: 58px;
}

/*
 * Pantallas medianas: se conserva legibilidad.
 * El scroll solo aparece cuando el ancho disponible
 * es realmente menor al necesario.
 */
@media (max-width: 1264px) {
  ::v-deep .exportaciones-table table {
    table-layout: auto;
    min-width: 1160px;
  }
}
</style>
